import { Box, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { useAppBar } from '../../../../../components/appBar/appBarContext'
import DebtCard from '../../../../../components/card/loanCard/debtCard'
import EarlyPayment from '../../../../../components/card/loanCard/earlyPayment'
import FuturePassedLoansCard from '../../../../../components/card/loanCard/futurePassedLoansCard'
import InstallmentPaymentCart from '../../../../../components/card/loanCard/InstallmentPaymentCart'
import EmptyStyle from '../../../../../components/emptyStyles/emptyStyle'
import BasicTab from '../../../../../components/tab/basicTab'
import { useAuth } from '../../../../../config/AuthProvider/authProvider'
import { REPAYMENT_TYPE } from '../../../../../config/cacheKey'
import { TRepaymentType } from '../../../../../models/registration.model'
import { IGetInstallmentsPaymentInfoResponse, INotSettledInstallments, IOtherPayments, ISettledInstallments } from '../../../../../models/repayment.model'
import { changeRouteType, getNextInnerState } from '../../../../../redux/handleBackBtn/handleBackBtnSlice'
import { getNotSeteledInstallments } from '../../../../../redux/notSetteledInstallments/notSettledSlice'
import { GetInstallmentsPaymentInfo } from '../../../../../services/repayment.service'
import { IContainerApp } from '../../containerApp/IContainerApp'
import AssignedLoansSkeleton from './assignedLoansSkeleton'
import { useNavigate } from 'react-router-dom'


interface IDept {
    installmentDeptAmount: number;
    penaltyDeptAmount: number;
    deptAmount: number;
}

const AssignedLoans = ({ referenceKey, setStep }: IContainerApp) => {
    const navigate = useNavigate();
    const queryClient: any = useQueryClient()
    const [notSettledInstallments, setNotSettledInstallments] = useState<INotSettledInstallments[]>([]);
    const [settledInstallments, setSettledInstallments] = useState<ISettledInstallments[]>([]);
    const [otherPayments, setOtherPayments] = useState<IOtherPayments[]>([]);
    const [dept, setDept] = useState<IDept>();
    const dispatch = useDispatch();
    const { referenceKey: refKey } = useAuth();
    const repaymentType: TRepaymentType = queryClient.getQueryData(REPAYMENT_TYPE) ?? localStorage.getItem(REPAYMENT_TYPE);

    const tabItems = [];

    if (notSettledInstallments.length > 0) {
        tabItems.push({
            id: 0,

            title: <div className='whitespace-nowrap text-[0.875rem]'>
                {repaymentType === "SalaryDeduction" ? "اطلاعات اقساط" : "پرداخت نشده"}
            </div>,
            child: (
                <>
                    {notSettledInstallments.map((item, index) => (
                        <Box key={index} sx={{ marginBottom: ".7rem" }}>
                            <FuturePassedLoansCard
                                date={item.dueDatePersian}
                                price={item.totalAmount}
                                status="waited"
                                textColor=""
                                paymentDatePersian={item.lastPaymentDatePersian}
                                amount={item.amount}
                                penaltyAmount={item.penaltyAmount}

                            />
                        </Box>
                    ))}
                </>
            ),
        });
    } else {
        tabItems.push({
            id: tabItems.length,
            title: <div className='whitespace-nowrap text-[0.875rem]'>
                {repaymentType === "SalaryDeduction" ? "اطلاعات اقساط" : "پرداخت نشده"}
            </div>,
            child: (
                <>
                    <EmptyStyle emphasisedWordsColor="" icon={<img src='images/emptyInstallment.svg' style={{ paddingLeft: "5px" }}></img>} text="قسط پرداخت نشده ای ندارید" emphasisedWords={[]} />
                </>
            ),
        });
    }

    if (settledInstallments.length > 0) {
        tabItems.push({
            id: tabItems.length,
            title: <div className='whitespace-nowrap text-[0.875rem]'>
                پرداخت شده
            </div>,
            child: (
                <>
                    {settledInstallments.map((item, index) => (
                        <Box key={index} sx={{ marginBottom: ".7rem" }}>
                            <FuturePassedLoansCard
                                date={item.dueDatePersian}
                                price={item.totalAmount}
                                status="setteled"
                                textColor=""
                                paymentDatePersian={item.lastPaymentDatePersian}
                                amount={item.amount}
                                penaltyAmount={item.penaltyAmount}
                                gateway={item.gateway}
                                transactionCode={item.transactionCode}
                                traceNumber={item.traceNumber}
                                settledInstallment
                            />
                        </Box>
                    ))}
                </>
            ),
        });
    } else {
        tabItems.push({
            id: tabItems.length,
            title:
                <div className='whitespace-nowrap text-[0.875rem]'>
                    پرداخت شده
                </div>,
            child: (
                <>
                    <EmptyStyle emphasisedWordsColor="" icon={<img src='images/emptyInstallment.svg' style={{ paddingLeft: "5px" }}></img>} text="قسط پرداخت شده ای ندارید" emphasisedWords={[]} />

                </>
            ),
        });
    }
    if (otherPayments.length > 0) {
        tabItems.push({
            id: tabItems.length,
            title:
                <div className='whitespace-nowrap text-[0.875rem]'>
                    سایر پرداخت‌ها
                </div>,
            child: (
                <>
                    {otherPayments.map((item, index) => (
                        <Box key={index} sx={{ marginBottom: ".7rem" }}>
                            <FuturePassedLoansCard
                                date={item.paymentDatePersian}
                                price={item.amount}
                                status="Verified"
                                textColor=""
                                paymentDatePersian={''}
                                amount={item.amount}
                                gatewayPaymentToken={item.gatewayPaymentToken}
                            // penaltyAmount={null}
                            />
                        </Box>
                    ))}
                </>
            ),
        });
    } else {
        tabItems.push({
            id: tabItems.length,
            title:
                <div className='whitespace-nowrap text-[0.875rem]'>
                    سایر پرداخت‌ها
                </div>,
            child: (
                <div className='flex items-center h-[50svh]'>
                    <EmptyStyle emphasisedWordsColor="#BBA57A" icon={<img src='images/emptyInstallment.svg' style={{ paddingLeft: "5px" }}></img>} text="اطلاعاتی برای نمایش وجود ندارد" emphasisedWords={['اطلاعاتی']} />
                </div>
            ),
        });
    }

    const { setHeader } = useAppBar();
    useEffect(() => {

        GetInstallmentsPaymentInfoMutate({ referenceKey: referenceKey ? referenceKey : refKey! })
        dispatch(changeRouteType({ routeType: 'loans' }));
        setHeader('مشاهده اقساط', 'loans')


    }, [])
    const { mutate: GetInstallmentsPaymentInfoMutate, isLoading } = useMutation(
        GetInstallmentsPaymentInfo,
        {
            onSuccess: (data: IGetInstallmentsPaymentInfoResponse) => {
                if (data) {
                    setDept({
                        deptAmount: data.deptAmount,
                        installmentDeptAmount: data.installmentDeptAmount,
                        penaltyDeptAmount: data.penaltyDeptAmount
                    })

                    setNotSettledInstallments(data.notSettledInstallments);
                    dispatch(getNotSeteledInstallments(data.notSettledInstallments))
                    setSettledInstallments(data.settledInstallments);
                    setOtherPayments(data.otherPayments);
                }
            },
        }
    );

    const handleEarlyPayment = () => {
        navigate('/loans/installments/FutureLoans')
    }

    if (isLoading) {
        return (<AssignedLoansSkeleton />)
    } else {
        return (

            <div >
                <Grid container flexDirection={"column"} sx={{ height: "100%" }} className='overflow-auto'>
                    {(repaymentType === 'Online' || repaymentType === "OnlineWithPrepaymentGoldMortgage" || repaymentType === "OnlineWithPrepayment") &&
                        <>
                            {dept?.deptAmount! > 0 &&
                                <Grid item
                                    sx={{ height: (dept?.deptAmount === 0 && notSettledInstallments.length > 0) ? ' 120px' : ' 75px' }}
                                >
                                    <DebtCard price={dept?.deptAmount!} />
                                </Grid>
                            }
                            {(dept?.deptAmount === 0 && notSettledInstallments.length > 0 && settledInstallments.length !== 0) &&
                                <Grid item
                                    sx={{ height: (dept?.deptAmount === 0 && notSettledInstallments.length > 0) ? ' 150px' : ' 75px' }}>
                                    <EarlyPayment onClick={() => handleEarlyPayment()} />
                                </Grid>
                            }
                            {(dept?.deptAmount === 0 && settledInstallments.length === 0) &&
                                <Grid item
                                    sx={{ height: (dept?.deptAmount === 0 && notSettledInstallments.length > 0) ? ' 150px' : ' 75px' }}>
                                    <InstallmentPaymentCart onClick={() => handleEarlyPayment()} />
                                </Grid>
                            }
                        </>
                    }
                    <Grid item sx={{
                        overflowY: "auto",
                        height: (repaymentType === 'Online' || repaymentType === "OnlineWithPrepaymentGoldMortgage" || repaymentType === "OnlineWithPrepayment") ? (dept?.deptAmount === 0 && notSettledInstallments.length > 0) ? ' calc(100% - 120px)' : 'calc(100% - 75px)' : '100%'
                    }} >
                        {dept ? <BasicTab tabs={tabItems} /> : <AssignedLoansSkeleton />}
                    </Grid>
                </Grid>
            </div>

        )

    }

}

export default AssignedLoans
